module.exports = __webpack_public_path__ + "media/images/sp/register/img_register_flow-9246eed26dd89fedcc20053417575bf8.png";